import { render } from "./folder-inner.vue?vue&type=template&id=9e3d2d52"
import script from "./folder-inner.vue?vue&type=script&lang=ts"
export * from "./folder-inner.vue?vue&type=script&lang=ts"
script.render = render

export default script